<template>
  <div
    class="insights-widget-sync-status"
    :class="{ 'still-syncing': isStillSyncing }"
  >
    <div>
      <div class="insights-widget-sync-status-title d-flex align-items-center mb-10">
        <i
          v-if="isStillSyncing"
          class="hi hi-spinner mr-5 text-black"
        />
        <strong>{{ title }}</strong>
      </div>

      <div class="insights-widget-sync-status-content">
        <template v-if="isStillSyncing">
          <p>This may take a few minutes</p>
        </template>
        <template v-else>
          <p>This is taking longer than expected. Please wait for a few more minutes and try reloading the page.</p>

          <AppButton
            class="d-block mt-30 mx-auto"
            type="primary"
            @click="reload"
          >
            Reload page
          </AppButton>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import AppButton from '~/components/AppButton.vue';

export default {
  name: 'InsightsIntegrationSyncStatus',
  components: {
    AppButton,
  },
  props: {
    isStillSyncing: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
  },
  methods: {
    reload() {
      location.reload();

      return false;
    },
  },
};
</script>
